module.exports = __webpack_public_path__ + "img/chemical_engineer_intro.673ce553.jpg";